module.exports = __webpack_public_path__ + "static/media/sejal.23397cf9.jpg";